import { ICardFlip } from "Types/CardFlip";

import "./cardFlip.scss";

export const CardFlip = ({
  cardFlipFront,
  cardFlipBack,
  className,
  onClick,
  openChildren,
  children
}: ICardFlip): JSX.Element => {
  return (
    <>
      <div className={`card-flip ${className}`}>
        <div className='card-flip-inner'>
          <div className='card-flip-front'>{cardFlipFront}</div>
          <div className='card-flip-back' onClick={onClick}>
            {cardFlipBack}
          </div>
        </div>
      </div>
      {openChildren && children}
    </>
  );
};
